import { toFaqSchemaEntities } from "@/lib/mdx-faq";

export type FaqSchemaItem = {
  question: string;
  answer: string;
};

export function toFaqPageJsonLd(faqs: FaqSchemaItem[]): string | null {
  const mainEntity = toFaqSchemaEntities(faqs);

  if (mainEntity.length === 0) return null;

  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  });
}
